import clsx from "clsx";
import { element, elementType, node, oneOf, oneOfType, string } from "prop-types";
import { forwardRef } from "react";

import classes from "./Flex.module.scss";

export const ALIGN_CLASS = {
  center: classes.alignCenter,
  "flex-start": classes.alignStart,
  "flex-end": classes.alignEnd,
  stretch: classes.alignStretch,
  baseline: classes.alignBaseline,
  normal: classes.alignNormal,
};

export const DIRECTION_CLASS = {
  row: classes.directionRow,
  "row-reverse": classes.directionRowReverse,
  column: classes.directionColumn,
  "column-reverse": classes.directionColumnReverse,
};

const JUSTIFY_CLASS = {
  "flex-start": classes.justifyStart,
  "flex-end": classes.justifyEnd,
  center: classes.justifyCenter,
  "space-between": classes.justifyBetween,
  "space-around": classes.justifyAround,
  "space-evenly": classes.justifyEvenly,
};

export const GAP_CLASS = {
  GAP_0: classes.gap0,
  GAP_025: classes.gap025,
  GAP_050: classes.gap050,
  GAP_100: classes.gap100,
  GAP_150: classes.gap150,
  GAP_200: classes.gap200,
  GAP_250: classes.gap250,
  GAP_300: classes.gap300,
  GAP_350: classes.gap350,
  GAP_400: classes.gap400,
  GAP_450: classes.gap450,
  GAP_500: classes.gap500,
  GAP_600: classes.gap600,
  GAP_800: classes.gap800,
};

const Flex = forwardRef(
  (
    {
      as: Component = "div",
      alignItems = classes.alignCenter,
      direction,
      justifyContent = "flex-start",
      children,
      className,
      gap,
      ...props
    },
    ref
  ) => {
    return (
      <Component
        className={clsx(
          classes.flex,
          alignItems,
          direction,
          JUSTIFY_CLASS[justifyContent],
          gap,
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </Component>
    );
  }
);

Flex.displayName = "Flex";

Flex.propTypes = {
  as: elementType,
  alignItems: string,
  direction: string,
  justifyContent: oneOf(Object.keys(JUSTIFY_CLASS)),
  children: oneOfType([element, node, string]).isRequired,
  className: string,
  gap: string,
};

export default Flex;
